/* global globalThis */

import {
  InputAdornment,
  TextField,
  Theme,
  Typography,
  withStyles,
  WithStyles
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { createStyles } from '@material-ui/core/styles';
// import MuiAlert from '@material-ui/lab/Alert';
import { Search } from '@material-ui/icons';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';
import useAxios from 'axios-hooks';
import React, { useCallback, useMemo } from 'react';
import MainHeadingVariantTwo from '../../components/UI/MainHeading/VariantTwo';
import MainSection from '../../components/UI/MainSection/MainSection';
import MySnackbars from '../../components/UI/MySnackbars/MySnackbars';
import SubHeading from '../../components/UI/SubHeading/SubHeading';
import SubSection from '../../components/UI/SubSection/SubSection';
import DetailHeading from './DetailHeading';
import SourceInputComponent from './SourceInputComponent';
import SourceOutputComponent from './SourceOutputComponent';

import { IState, IUserState } from '../../models/states';
import { IDataRootObject } from './types';
// const drawerWidth = 150; TOO SMALL

import { connect } from 'react-redux';
import { RouteChildrenProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import history from '../../utilities/history';

const drawerWidth = 240;

function Alert(props) {
  return <div {...props} />;
}

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    inputTextStyles: {
      marginTop: 20,
      marginBottom: 20,
      fontSize: 14
    },
    outputTextStyles: {
      marginTop: 20,
      marginBottom: 20,
      fontSize: 14,
      textAlign: 'center'
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      height: '100vh',
      overflowY: 'auto'
    },
    drawerPaper: {
      width: drawerWidth,
      position: 'relative'
    },
    main: {
      display: 'flex',
      marginLeft: '-2rem',
      gap: '24px'
    },
    drawerContainer: {
      marginTop: -16
    },
    mainSectionContainer: {
      width: '100%'
    },
    warning: {
      fontSize: 14,
      color: '#f7ae64',
      display: 'inline-flex',
      alignItems: 'center',
      padding: 8,
      marginTop: 16,
      background: `${theme.palette.type === 'dark' ? '#333333' : '#f0f0f0'}`
    },
    formControl: {
      background: `${theme.palette.type === 'dark' ? '#333333' : '#f0f0f0'}`,
      margin: 12,
      padding: 4,
      border: 0,
      '&:before': {
        display: 'none'
      },
      '&:after': {
        display: 'none'
      }
    },
    noBorder: {
      border: 0,
      '&:before': {
        display: 'none'
      },
      '&:after': {
        display: 'none'
      }
    },
    successIcon: {
      color: '#a5ff4b',
      verticalAlign: 'middle',
      height: '2rem'
    },
    errorIcon: {
      color: '#ff6e6b',
      verticalAlign: 'middle',
      height: '2rem'
    },
    warningIcon: {
      color: '#f7ae64',
      verticalAlign: 'middle',
      height: '2rem'
    },
    noRightMargin: {
      marginRight: 0
    },
    listText: {
      paddingLeft: '6px',
      fontSize: '12px'
    },
    list: {
      marginLeft: '12px',
      marginRight: '12px'
    },
    fullWidth: {
      width: '100%'
    },
    confirmHeader: {
      height: '40px',
      backgroundColor: '#4e4e4e',
      padding: '0 24px',
      '& h6': {
        height: '20px',
        fontSize: '16px;',
        margin: 0,
        lineHeight: '40px'
      }
    },
    confirmBody: {
      padding: '32px 24px'
    },
    confirmFooter: {
      padding: '4px 24px'
    },
    connector: {
      border: '2px solid',
      marginLeft: '-10px',
      marginRight: '-10px',
      '&.primary': {
        marginTop: '10rem'
      },
      '&.secondary': {
        marginTop: '23.5rem'
      },
      '&.AS_OK': {
        color: `#7dd321`
      },
      '&.AS_ERROR': {
        color: `#ff6e6b`
      },
      '&.AS_WARNING': {
        color: `#f7ae64`
      }
    }
  });

const Deatil: React.FC<
  {
    loading: boolean;
    rows: IDataRootObject[];
    refetch: () => void;
    user: IUserState;
  } & WithStyles &
    RouteChildrenProps<{
      switcher_name: string;
    }>
> = ({
  loading,
  rows,
  classes,
  refetch,
  user,
  match: {
    params: { switcher_name }
  }
}) => {
  const [filter, setFilter] = React.useState('all');
  const [search, setSearch] = React.useState('');
  const [switchDetails, setSwitchDetails] = React.useState(null);
  const [openSnack, setOpenSnack] = React.useState(null);

  const switchTo = useCallback(({ account, channel, player, mode }) => {
    setSwitchDetails({ account, channel, player, mode });
  }, []);

  const row = useMemo(() => {
    return rows.find(
      (r) => r.switcher_name + '_' + r.type === decodeURI(switcher_name)
    );
  }, [rows, switcher_name]);

  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const [{}, executePost] = useAxios(
    {
      method: 'POST',
      headers: {
        Authorization: user.token
      }
    },
    { manual: true }
  );

  if (loading || !row) {
    return <i>Loading...</i>;
  }

  return (
    <MainSection>
      <div className={classes.main}>
        <div className={classes.drawerContainer}>
          <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
              paper: classes.drawerPaper
            }}
            anchor="left"
          >
            <Divider />
            <FormControl variant="outlined" className={classes.formControl}>
              <Select
                // id="customer-select-sel"
                value={filter}
                className={classes.noBorder}
                onChange={(e) => setFilter(e.target.value)}
              >
                <MenuItem value="all">All Customers</MenuItem>
                {Array.from(
                  new Set(
                    rows.map(
                      (r) => capitalize(r.type) + ' : ' + r.switcher_name
                    )
                  )
                ).map((c) => (
                  <MenuItem key={c} value={c}>
                    {c.split('.')[0]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div className={classes.list}>
              <TextField
                onChange={(e) => setSearch(e.target.value)}
                className={classes.fullWidth}
                placeholder={'Search by Switcher Name'}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  )
                }}
              />
              <Divider />
              <List>
                {rows
                  .filter((r) => {
                    if (
                      filter !== 'all' &&
                      filter !== r.type + ':' + r.switcher_name
                    ) {
                      return false;
                    }
                    if (
                      search &&
                      (r.type + ':' + r.switcher_name)
                        .toLowerCase()
                        .indexOf(search.toLowerCase()) === -1
                    ) {
                      return false;
                    }
                    return true;
                  })
                  .map((r, index) => (
                    <div key={r.switcher_name}>
                      <ListItem
                        onClick={() => {
                          history.push(
                            `/switcher/${r.switcher_name + '_' + r.type}`
                          );
                        }}
                        button
                      >
                        <ListItemIcon className={classes.noRightMargin}>
                          {r.status === 'AS_OK' ? (
                            <CheckCircleOutlineIcon
                              className={classes.successIcon}
                            />
                          ) : r.status === 'AS_WARNING' ? (
                            <ReportProblemOutlinedIcon
                              className={classes.warningIcon}
                            />
                          ) : (
                            <ErrorOutlineIcon className={classes.errorIcon} />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className={classes.listText}
                          primary={capitalize(r.type) + ' : ' + r.switcher_name}
                        />
                      </ListItem>
                      <Divider />
                    </div>
                  ))}
              </List>
            </div>
          </Drawer>
        </div>
        <div className={classes.mainSectionContainer}>
          <MainHeadingVariantTwo
            mainHeading={` ${capitalize(row.type) + ' : ' + row.switcher_name}`}
            onClick={() => history.push('/switcher')}
          />
          <SubSection>
            <SubHeading>
              <DetailHeading switchTo={switchTo} row={row} />
            </SubHeading>
            <Grid container spacing={8}>
              <Grid item xs={7}>
                <Typography className={classes.inputTextStyles}>
                  Input sources{' '}
                </Typography>
                <div>
                  <SourceInputComponent
                    data={
                      row.active_source.stream_id === 1
                        ? row.active_source
                        : row.backup_source
                    }
                  />
                  <SourceInputComponent
                    data={
                      row.active_source.stream_id === 2
                        ? row.active_source
                        : row.backup_source
                    }
                  />
                </div>
              </Grid>
              <Grid item xs={1}>
                <Divider
                  className={`${classes.connector} ${
                    row.active_source.status
                  } ${row.active_source.name.toLowerCase()}`}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography className={classes.outputTextStyles}>
                  Channel Output
                </Typography>
                <SourceOutputComponent data={row} />
                {row.status === 'AS_WARNING' && (
                  <Alert className={classes.warning}>
                    <WarningOutlinedIcon style={{ marginRight: 8 }} />
                    Loss of redundancy. There is no backup if playout fails!{' '}
                  </Alert>
                )}
              </Grid>
            </Grid>
          </SubSection>
        </div>
      </div>
      {/* <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <SourceOutputComponent />
      </Popover> */}
      <Dialog
        open={!!switchDetails}
        onClose={() => setSwitchDetails(null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className={classes.confirmHeader}>
          Switch Source
        </DialogTitle>
        <DialogContent className={classes.confirmBody}>
          <DialogContentText id="alert-dialog-description">
            Are you sure that you want to switch the input source to{' '}
            {switchDetails &&
              (switchDetails.mode === 'auto'
                ? 'Automatic'
                : row.backup_source.type)}
            ?
          </DialogContentText>
        </DialogContent>
        <Divider color="rgba(0, 0, 0, 0.16)" />
        <DialogActions className={classes.confirmFooter}>
          <Button onClick={() => setSwitchDetails(null)} color="default">
            No
          </Button>
          <Button
            onClick={async () => {
              const switchingTo =
                switchDetails && switchDetails.mode === 'auto'
                  ? 'Automatic'
                  : row.backup_source.name;

              const params = {
                ...switchDetails,
                user: user.userInfo.userId,
                type: 'immediate',
                id: row.switcher_id,
                stream: row.backup_source.stream_id
              };
              setSwitchDetails(null);
              // post to backend
              try {
                await executePost({
                  url: `${globalThis.UI_CONFIG.backend_url}/v1/switch`,
                  params
                });

                setOpenSnack({
                  variant: 'success',
                  message: `Input source switched to ${switchingTo}`
                });
                setTimeout(() => {
                  refetch();
                }, 1000);
              } catch (e) {
                setOpenSnack({
                  variant: 'error',
                  message: `There was an error while posting the data`
                });
                console.log('debug: error', e);
              }
            }}
            autoFocus
            color="default"
            variant="outlined"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <MySnackbars
        open={!!openSnack}
        variant={openSnack ? openSnack.variant : 'success'}
        onClose={() => setOpenSnack(null)}
        message={openSnack ? openSnack.message : ''}
      />
    </MainSection>
  );
};

interface IAppStateProps {
  user: IUserState;
}

const mapStateToProps = (state: IState) => {
  return {
    user: state.user
  };
};

export default withRouter(
  withStyles(styles)(connect<IAppStateProps>(mapStateToProps, {})(Deatil))
);
